import { Text } from '@shared/components';
import { Dropdown } from '@shared/components/plugin-components';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { useAuthContext } from '@shared/contexts/useAuthContext';
import { hasChatsAccess } from '@shared/utils/permissions';
import { CHATS_ROUTE } from 'clerk_common/constants/urls/routes';
import { useNavigate } from 'react-router-dom';

const Menu = () => {
  const { logout } = useAuthContext();
  const { hasVee, isVoomaAdmin } = useMeContext();
  const navigate = useNavigate();

  const getItems = () => {
    return [
      {
        node: (
          <button
            className="w-full py-2 text-left"
            onClick={() => {
              navigate('/');
            }}
            type="button"
          >
            <Text type="body-xs">Home</Text>
          </button>
        ),
      },
      ...(hasChatsAccess({ hasVee, isVoomaAdmin })
        ? [
            {
              node: (
                <button
                  className="w-full py-2 text-left"
                  onClick={() => {
                    navigate(CHATS_ROUTE);
                  }}
                  type="button"
                >
                  <Text type="body-xs">Chats</Text>
                </button>
              ),
            },
          ]
        : []),
      {
        node: (
          <div
            className="py-2"
            onClick={() => {
              navigate('/settings');
            }}
          >
            <Text type="body-xs">Account settings</Text>
          </div>
        ),
      },
      {
        node: (
          <div onClick={logout} className="py-2">
            <Text type="body-xs">Log out</Text>
          </div>
        ),
      },
    ];
  };

  return <Dropdown items={getItems()} />;
};
export default Menu;
